import { useState, useCallback } from 'react';

export const useBillingError = () => {
  const [billingError, setBillingError] = useState({
    isOpen: false,
    title: '',
    message: '',
    subText: '',
    actionText: 'Aceptar',
    onClose: null,
  });

  const showBillingError = useCallback(
    ({
      title,
      message,
      subText = '',
      actionText = 'Aceptar',
      onClose = null,
    }) => {
      setBillingError({
        isOpen: true,
        title,
        message,
        subText,
        actionText,
        onClose,
      });
    },
    []
  );

  const clearBillingError = useCallback(() => {
    setBillingError(prev => {
      // si esta llamada definió un comportamiento especial, se ejecuta
      if (typeof prev.onClose === 'function') {
        prev.onClose();
      }

      return {
        isOpen: false,
        title: '',
        message: '',
        subText: '',
        actionText: 'Aceptar',
        onClose: null,
      };
    });
  }, []);

  return {
    billingError,
    showBillingError,
    clearBillingError,
  };
};
